import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const ActivitiesList = lazy(() =>
  import("../../container/activities/ActivitiesList")
);
const AddActivity = lazy(() =>
  import("../../container/activities/components/createActivityForm")
);

function IconsRoute() {
  return (
    <Routes>
      <Route path="/" element={<ActivitiesList />} />
      <Route path="/add-activity" element={<AddActivity />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
